export default "__VITE_ASSET__jgXwvw7I__"